import ZJApi from './api'
import utils from '../../utils'

const info = {
    service: 'BaseDataService',
    controller: 'Equipment'
};

const methods = [
    'AddEquipment',
    'UpdateEquipment',
    'GetEquipmentById',
    'DelEquipment',
    'GetEquipmentPagingList',
    'GetEquipmentMangeList'
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
};

const MonitorApi = ZJApi.defineNewApi('MonitorApi', factory);

export default MonitorApi;